import { memo, useMemo } from "react";
import type { CrmSetupBillingVariant } from "../../types";
import CrmSetupStepContentCard from "./CrmSetupStepContentCard";

export interface CrmSetupServiceContractStepProps {
  /**
   * Contexto do tenant (organização).
   *
   * Importante: a decisão Meta vs Fluxmed agora é baseada em fontes reais:
   * - Endpoint ativo (Meta)
   * - Contrato executado (Fluxmed)
   */
  organizationId?: string;
  /**
   * Define se o botão "Finalizar e acessar painel" pode ficar ativo.
   * (Mantido por compatibilidade, mas hoje o fluxo deixa sempre habilitado.)
   */
  onContractReadyChange?: (ready: boolean) => void;
}

const CrmSetupServiceContractStep = memo(
  ({ onContractReadyChange }: CrmSetupServiceContractStepProps) => {
    /**
     * Temporário (conforme requisito):
     * - Meta: finalizar sempre habilitado
     * - Fluxmed: finalizar sempre habilitado (mesmo exibindo seleção de pacotes)
     *
     * O billingVariant é mantido como "unknown" aqui; a seleção real do canal é exibida
     * no passo de configuração. Quando o canal estiver definido por fonte real, este passo
     * poderá receber `billingVariant` explicitamente por props/hook.
     */
    const billingVariant: CrmSetupBillingVariant = "unknown";

    if (onContractReadyChange) {
      onContractReadyChange(true);
    }

    const { title, description } = useMemo(
      () => ({
        title: "Contrato e franquia",
        description:
          "Por enquanto, esta etapa não bloqueia a finalização. Escolha Meta ou Fluxmed no passo de configuração para seguir com a cobrança adequada.",
      }),
      [],
    );

    return (
      <CrmSetupStepContentCard
        title={title}
        description={description}
        billingVariant={billingVariant}
      />
    );
  },
);

CrmSetupServiceContractStep.displayName = "CrmSetupServiceContractStep";

export default CrmSetupServiceContractStep;
